import { render, staticRenderFns } from "./ActivityHistoryCreate.vue?vue&type=template&id=7489e848&scoped=true&"
import script from "./ActivityHistoryCreate.vue?vue&type=script&lang=js&"
export * from "./ActivityHistoryCreate.vue?vue&type=script&lang=js&"
import style0 from "./ActivityHistoryCreate.vue?vue&type=style&index=0&id=7489e848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7489e848",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCheckbox,VCombobox,VDatePicker,VDialog,VForm,VMenu,VSelect,VTextarea})
